import { Link } from 'react-router-dom';
import styled, { css, DefaultTheme } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

type WithIsSelected = { $isSelected: boolean };

const addBaseCardStyles = (isSelected: boolean, theme: DefaultTheme) => css`
    border: solid 1px ${isSelected ? theme.Utility.cta : theme.Surface.border};
    border-radius: 8px;
    cursor: pointer;
    flex: 1;
    min-height: 72px;
    transition: background 400ms ease 0ms;

    align-items: center;
    justify-content: center;
    flex-direction: column;

    &:hover {
        background: ${theme.Surface.secondary};
    }
`;

export const SmallDayCard = styled(Link)<WithIsSelected>`
    display: flex;
    ${({ $isSelected, theme }) => addBaseCardStyles($isSelected, theme)};

    ${BaseStyle.Mixins.screenSizes.medium} {
        display: none;
    }
`;

export const DayOfWeekAbbrev = styled.div<WithIsSelected>`
    display: flex;
    align-items: center;
    justify-content: center;

    color: ${({ $isSelected, theme }) => ($isSelected ? theme.Utility.cta : theme.Text.secondary)};
    flex: 1;
    ${BaseStyle.Mixins.fontStyles.ui['10mCaps']}
`;

export const DayOfMonth = styled.h5<WithIsSelected>`
    color: ${({ $isSelected, theme }) => ($isSelected ? theme.Utility.cta : theme.Text.primary)};
    flex: 1;
    line-height: initial;
`;

export const NumberOfGames = styled.div`
    color: ${({ theme }) => theme.Text.secondary};
    flex: 1;
    line-height: initial;
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const LargeNumberOfGames = styled(NumberOfGames)`
    display: flex;
    align-items: center;
    min-height: 24px;

    color: ${({ theme }) => theme.Text.primary};
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        display: none;
    }
`;

export const ExtraLargeNumberOfGames = styled(NumberOfGames)`
    color: ${({ theme }) => theme.Text.primary};
    display: none;
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        display: initial;
    }
`;

export const LargeDayCard = styled(Link)<WithIsSelected>`
    display: none;
    min-height: 102px;
    padding: 16px 12px;
    ${({ $isSelected, theme }) => addBaseCardStyles($isSelected, theme)};

    ${BaseStyle.Mixins.screenSizes.medium} {
        display: flex;
    }
`;

export const TopRow = styled.div`
    display: flex;
    flex: 1;
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    width: 100%;
`;

export const BottomRow = styled.div<WithIsSelected>`
    align-items: center;
    display: flex;
    flex: 1;
    padding-top: 32px;
    width: 100%;

    svg {
        fill: ${({ theme, $isSelected }) => ($isSelected ? theme.Text.secondary : theme.Utility.cta)};
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
    }
`;

export const LargeDayOfWeekLetter = styled.span`
    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        display: none;
    }
`;

export const LargeDayOfWeekAbbrev = styled.span`
    display: none;
    text-transform: uppercase;

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        display: initial;
    }
`;

export const MonthDay = styled.span`
    flex: 1;
`;

export const DaysDisplayContainer = styled.div<{ $addBottomMargin?: boolean }>`
    margin-bottom: ${({ $addBottomMargin }) => ($addBottomMargin ? '24px' : 0)};
`;

export const Days = styled.div<{ $padBottom?: boolean }>`
    display: flex;
    ${BaseStyle.Mixins.gaps.small}

    ${({ $padBottom }) =>
        $padBottom &&
        css`
            padding-bottom: 8px;

            ${BaseStyle.Mixins.screenSizes.medium} {
                padding: 8px 0;
            }
        `}
`;
